import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FlaskConical, Syringe } from "lucide-react";
import api from "../lib/api";

export default function Research() {
  const [products, setProducts] = useState([]);

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  return (
    <section id="research" className="relative py-24 md:py-32 border-t border-white/10 bg-[#050507]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="text-[11px] tracking-[0.4em] uppercase text-[#00F0FF] mb-4 font-mono2"
        >
          // Research
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="font-display font-black text-3xl md:text-5xl uppercase tracking-tighter mb-4"
        >
          Reconstitution &amp;<br /><span className="text-[#00F0FF] neon-text">Dosage Guides</span>
        </motion.h2>
        <p className="text-xs text-slate-500 font-mono2 max-w-xl mb-14">
          Recommended starting protocols for each compound. Research use only — always verify against current literature.
        </p>

        <div className="grid md:grid-cols-2 gap-5" data-testid="research-grid">
          {products.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.08 }}
              className="border border-white/10 hover:border-[#00F0FF]/40 bg-white/[0.02] p-6 transition-colors"
              data-testid={`research-${p.id}`}
            >
              <h3 className="font-display font-extrabold text-lg uppercase tracking-tight mb-4">{p.name}</h3>
              <div className="space-y-4">
                <div className="flex gap-3">
                  <FlaskConical size={18} className="text-[#00F0FF] shrink-0 mt-0.5" />
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-slate-500 font-mono2 mb-1">Reconstitution</p>
                    <p className="text-sm text-slate-300 font-mono2 leading-relaxed">{p.reconstitution || "Guide coming soon — reconstitute with bacteriostatic water and refrigerate."}</p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <Syringe size={18} className="text-[#00F0FF] shrink-0 mt-0.5" />
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-slate-500 font-mono2 mb-1">Dosage</p>
                    <p className="text-sm text-slate-300 font-mono2 leading-relaxed">{p.dosing}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
